<div class="min-h-screen bg-station-cream px-4 py-12 md:py-16">
  <article
    class="max-w-3xl mx-auto bg-white rounded-xl shadow-lg p-6 md:p-10 [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:text-flap-black [&_h2]:mt-8 [&_h2]:mb-3 [&_h3]:text-lg [&_h3]:font-semibold [&_h3]:text-flap-black [&_h3]:mt-5 [&_h3]:mb-2 [&_p]:text-rail-gray [&_p]:leading-relaxed [&_p]:mb-3 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:mb-3 [&_li]:text-rail-gray [&_li]:leading-relaxed [&_li]:mb-1 [&_strong]:font-semibold [&_strong]:text-flap-black [&_a]:text-signal-orange [&_a]:font-semibold hover:[&_a]:underline"
  >
    <h1 class="text-3xl md:text-4xl font-bold text-flap-black mb-2">Privacy Policy</h1>
    <p><strong>Effective Date:</strong> July 24, 2026</p>
    <p><strong>Website:</strong> FlippyBoards.com</p>

    <h2>1. Introduction</h2>
    <p>
      This Privacy Policy describes how FlippyBoards.com ("we," "us," or "our") collects, uses, and
      protects your personal information when you use the FlippyBoards.com service ("the Service").
      We are committed to protecting your privacy and handling your data responsibly.
    </p>

    <h2>2. Information We Collect</h2>
    <h3>2.1 Information You Provide</h3>
    <ul>
      <li>
        <strong>Email Address:</strong> We collect your email address when you create an account.
        This is used for account identification, authentication, and communication regarding your
        account.
      </li>
      <li>
        <strong>Name:</strong> We collect the display name you provide when you create an account.
      </li>
      <li>
        <strong>Account Credentials:</strong> If you sign up with email and password, we store your
        password in encrypted (hashed) form. We never store plaintext passwords.
      </li>
      <li>
        <strong>Google Sign-In:</strong> If you sign in with Google, we receive your name, email
        address, and Google account identifier from Google. We do not receive or store your Google
        password. Google's handling of your data is governed by Google's own privacy policy.
      </li>
      <li>
        <strong>User Content:</strong> We store the boards and messages you create with your
        account.
      </li>
    </ul>

    <h3>2.2 Automatically Collected Information</h3>
    <ul>
      <li>
        <strong>IP Address:</strong> We collect and log your IP address when you access the Service
        for security, debugging, and abuse prevention purposes.
      </li>
      <li>
        <strong>Usage Data:</strong> We collect information about how you use the Service, including
        pages visited, features used, time and date of access, browser type and version, device
        information, and actions performed within the Service.
      </li>
    </ul>

    <h3>2.3 Information We Do Not Collect</h3>
    <p>We do not collect:</p>
    <ul>
      <li>Social media information or links</li>
      <li>Payment information</li>
      <li>Sensitive personal information beyond what is listed above</li>
    </ul>

    <h2>3. How We Use Your Information</h2>
    <p>We use the collected information for the following purposes:</p>

    <h3>3.1 Service Delivery</h3>
    <ul>
      <li>To create and manage your account</li>
      <li>To store and display the boards and messages you create</li>
      <li>To authenticate your identity when you log in</li>
      <li>To display a profile avatar via Gravatar (see Section 5.3)</li>
    </ul>

    <h3>3.2 Service Improvement</h3>
    <ul>
      <li>To troubleshoot technical issues</li>
      <li>To develop new features and functionality</li>
    </ul>

    <h3>3.3 Security and Compliance</h3>
    <ul>
      <li>To detect, prevent, and address security issues, fraud, or abuse</li>
      <li>To maintain logs for debugging and security purposes</li>
      <li>To comply with legal obligations</li>
    </ul>

    <h3>3.4 Communication</h3>
    <ul>
      <li>
        To send you transactional emails such as email verification and password reset messages
      </li>
      <li>To send you important notices about your account or the Service</li>
      <li>To respond to your inquiries or support requests</li>
    </ul>
    <p>We do not use your information for marketing purposes.</p>

    <h2>4. Data Storage and Security</h2>
    <h3>4.1 Data Storage</h3>
    <p>
      Your personal information and content are stored on secure servers. We implement appropriate
      technical and organizational measures to protect your data against unauthorized access, loss,
      or destruction.
    </p>

    <h3>4.2 Data Retention</h3>
    <ul>
      <li>We retain your account information and content for as long as your account is active</li>
      <li>
        Log data (including IP addresses) is retained for a limited period for security and
        debugging purposes
      </li>
      <li>
        Upon account deletion, your data is permanently removed from our production systems
        promptly, typically immediately
      </li>
    </ul>

    <h3>4.3 Security Measures</h3>
    <p>We use industry-standard security measures including:</p>
    <ul>
      <li>Encrypted data transmission (HTTPS/SSL)</li>
      <li>Encrypted (hashed) password storage</li>
      <li>Access controls and authentication</li>
      <li>Regular security assessments</li>
    </ul>
    <p>
      However, no method of transmission over the internet is 100% secure, and we cannot guarantee
      absolute security.
    </p>

    <h2>5. Data Sharing and Disclosure</h2>
    <h3>5.1 We Do Not Sell Your Data</h3>
    <p>We do not sell, rent, or trade your personal information to third parties.</p>

    <h3>5.2 Public Boards</h3>
    <p>
      FlippyBoards.com is a sharing service. Boards you create can be viewed by anyone who has the
      board's URL, and you may optionally protect a board with a passcode. The content of your
      boards (your messages) is therefore visible to anyone you share a board link with, or anyone
      who otherwise obtains the link and passcode. Your account information (name, email address) is
      not displayed on shared boards. Do not put information in a board that you are not comfortable
      sharing.
    </p>

    <h3>5.3 Third-Party Service Providers</h3>
    <p>
      We share limited information with trusted third-party service providers who assist us in
      operating the Service:
    </p>
    <ul>
      <li>
        <strong>Hosting provider (Railway):</strong> Our servers and databases are hosted on
        Railway, located in the United States.
      </li>
      <li>
        <strong>Content delivery and security (Cloudflare):</strong> Traffic to the Service is
        routed through Cloudflare, which processes IP addresses and request data to provide DNS,
        caching, and protection against attacks.
      </li>
      <li>
        <strong>Email provider (Resend):</strong> Transactional emails (verification, password
        reset) are delivered via Resend, which processes your email address for that purpose.
      </li>
      <li>
        <strong>Authentication (Google):</strong> If you choose to sign in with Google, Google
        processes your login and shares your basic profile information with us.
      </li>
      <li>
        <strong>Avatars (Gravatar):</strong> Profile avatars are provided by Gravatar (Automattic).
        To fetch your avatar, a hashed version of your email address is sent to Gravatar. If you do
        not have a Gravatar account, a default avatar is shown.
      </li>
    </ul>
    <p>
      These providers are contractually obligated to protect your information and use it only for
      the purposes we specify.
    </p>

    <h3>5.4 Legal Requirements</h3>
    <p>We may disclose your information if required to do so by law or in response to:</p>
    <ul>
      <li>Valid legal processes (subpoenas, court orders)</li>
      <li>Requests from government authorities</li>
      <li>Protection of our rights, property, or safety</li>
      <li>Prevention of fraud or security threats</li>
    </ul>

    <h2>6. Your Data Rights</h2>
    <h3>6.1 Access</h3>
    <p>You have the right to access your personal information at any time through your account.</p>

    <h3>6.2 Correction</h3>
    <p>
      You can update your account information at any time through your profile settings. If you need
      assistance, contact us (see Section 14).
    </p>

    <h3>6.3 Deletion</h3>
    <p>
      You have the right to request deletion of your account and all associated data at any time.
      You can:
    </p>
    <ul>
      <li>Delete your account through your profile settings</li>
      <li>Contact us (see Section 14) to request deletion</li>
    </ul>
    <p>
      Upon deletion, we will permanently remove your data, except where we are required to retain
      certain information for legal compliance.
    </p>

    <h3>6.4 Data Portability</h3>
    <p>
      You may request an export of your data by contacting us (see Section 14). We will provide your
      data in a commonly used, machine-readable format, including:
    </p>
    <ul>
      <li>Your account information</li>
      <li>All boards and messages</li>
      <li>Associated metadata</li>
    </ul>

    <h2>7. Cookies and Tracking Technologies</h2>
    <p>We use only essential cookies required for the Service to function:</p>
    <ul>
      <li><strong>Session Cookies:</strong> To maintain your logged-in session</li>
      <li>
        <strong>Authentication Cookies:</strong> To verify your identity and keep you logged in
      </li>
    </ul>
    <p>
      We do not use tracking cookies or analytics cookies. You can control cookies through your
      browser settings, but disabling essential cookies will prevent you from using the Service.
    </p>

    <h2>8. Children's Privacy</h2>
    <p>
      The Service is not intended for users under the age of 13. We do not knowingly collect
      personal information from children under 13. If you believe we have collected information from
      a child under 13, please contact us immediately, and we will delete such information.
    </p>

    <h2>9. International Data Transfers</h2>
    <p>
      Your information is stored on servers located in the United States. If you are accessing the
      Service from outside the United States, your information will be transferred to and processed
      in the United States. We ensure that appropriate safeguards are in place to protect your
      information in accordance with this Privacy Policy.
    </p>

    <h2>10. Changes to This Privacy Policy</h2>
    <p>
      We may update this Privacy Policy from time to time. We will notify you of material changes
      by:
    </p>
    <ul>
      <li>Posting the updated policy on the Service with a new effective date</li>
      <li>
        Sending an email notification to your registered email address (for significant changes)
      </li>
    </ul>
    <p>
      Your continued use of the Service after changes are posted constitutes acceptance of the
      updated Privacy Policy.
    </p>

    <h2>11. Third-Party Links</h2>
    <p>
      The Service may contain links to third-party websites or services, and boards created by users
      may contain content referencing third parties. We are not responsible for the privacy
      practices of these third parties. We encourage you to review their privacy policies before
      providing any personal information.
    </p>

    <h2>12. California Privacy Rights (CCPA)</h2>
    <p>
      If you are a California resident, you have additional rights under the California Consumer
      Privacy Act (CCPA):
    </p>
    <ul>
      <li>Right to know what personal information is collected</li>
      <li>Right to know if personal information is sold or shared (we do not sell your data)</li>
      <li>Right to request deletion of personal information</li>
      <li>Right to non-discrimination for exercising your privacy rights</li>
    </ul>
    <p>To exercise these rights, contact us (see Section 14).</p>

    <h2>13. European Privacy Rights (GDPR)</h2>
    <p>
      If you are located in the European Economic Area (EEA), you have rights under the General Data
      Protection Regulation (GDPR):
    </p>
    <ul>
      <li>Right of access to your personal data</li>
      <li>Right to rectification of inaccurate data</li>
      <li>Right to erasure ("right to be forgotten")</li>
      <li>Right to restriction of processing</li>
      <li>Right to data portability</li>
      <li>Right to object to processing</li>
      <li>Right to withdraw consent</li>
    </ul>
    <p>Our legal basis for processing your data is:</p>
    <ul>
      <li><strong>Contract Performance:</strong> To provide the Service you've signed up for</li>
      <li><strong>Legitimate Interest:</strong> To improve the Service and ensure security</li>
      <li><strong>Consent:</strong> Where you have provided explicit consent</li>
    </ul>
    <p>To exercise these rights, contact us (see Section 14).</p>

    <h2>14. Contact Us</h2>
    <p>
      If you have any questions, concerns, or requests regarding this Privacy Policy or our data
      practices, please contact us at:
    </p>
    <p>
      <a href="mailto:hello@flippyboards.com">hello&#64;flippyboards.com</a>
    </p>
    <p>We will respond to your inquiry within 30 days.</p>

    <h2>15. Data Protection Officer</h2>
    <p>
      If required by law, we will appoint a Data Protection Officer. Contact information will be
      provided here when applicable.
    </p>

    <hr class="my-8 border-border-subtle" />
    <p><strong>Last Updated:</strong> September 4, 2026</p>
    <p><strong>FlippyBoards.com</strong></p>
  </article>
</div>
